import React from 'react';

import { BearingEnvelope, TrussEnvelope } from '@paragon/contract-library';
import { Direction2D, Point2D } from '@paragon/geometry-library';

import { convertFromLayoutToDesignCoordinates } from '../../library/layout-geometry/coordinates';
import { LabelVisual } from '../util/LabelVisual';

const LABEL_FONT_SIZE = 8;
const LABEL_OFFSET_DISTANCE = 10;

export function EnvelopeEndLabels(props: {
  elevation: number;

  alwaysOnTop: boolean;
  envelope: Pick<TrussEnvelope | BearingEnvelope, 'leftPoint' | 'rightPoint'>;
  hiddenEndLabel?: 'left' | 'right';
  leftEndLabel?: string;
  rightEndLabel?: string;
}) {
  const leftPoint = Point2D.fromObject(props.envelope.leftPoint);
  const rightPoint = Point2D.fromObject(props.envelope.rightPoint);

  const labelOffset = Direction2D.fromPoints(rightPoint, leftPoint).toVector(LABEL_OFFSET_DISTANCE);

  const leftPointLabelPosition = convertFromLayoutToDesignCoordinates(
    leftPoint.add(labelOffset).to3D(props.elevation ?? 0),
  ).toArray();

  const rightPointLabelPosition = convertFromLayoutToDesignCoordinates(
    rightPoint.subtract(labelOffset).to3D(props.elevation ?? 0),
  ).toArray();

  return (
    <>
      {props.hiddenEndLabel !== 'left' && (
        <LabelVisual position={leftPointLabelPosition} fontSize={LABEL_FONT_SIZE} alwaysOnTop={props.alwaysOnTop}>
          {props.leftEndLabel ?? 'Left'}
        </LabelVisual>
      )}

      {props.hiddenEndLabel !== 'right' && (
        <LabelVisual position={rightPointLabelPosition} fontSize={LABEL_FONT_SIZE} alwaysOnTop={props.alwaysOnTop}>
          {props.rightEndLabel ?? 'Right'}
        </LabelVisual>
      )}
    </>
  );
}
